import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme} from "@mui/material";
import {formatCurrency} from "../utils/formatters";

const SUMMARY_ROWS = [
    {label: 'Volume - Lost Customer Impact', key: 'volumeLostCustomer'},
    {label: 'Volume - New Customer Impact', key: 'volumeNewCustomer'},
    {label: 'Volume - Discontinued Product Impact', key: 'volumeDiscontinuedProduct'},
    {label: 'Volume - New Product Impact', key: 'volumeNewProduct'},
    {label: 'Price - Products with increased price Impact', key: 'priceIncreasedProduct'},
    {label: 'Price - Products with decreased price Impact', key: 'priceDecreasedProduct'},
    {label: 'Volume - Products with increased volume Impact', key: 'volumeIncreasedProduct'},
    {label: 'Volume - Products with decreased volume Impact', key: 'volumeDecreasedProduct'},
    {label: 'Mix Impact', key: 'mix'},
    {label: 'Impact Total', key: 'total', isBold: true}
];

const isRowSelectable = (row) => !row.isBold && row.key !== 'mix';

export const ProfitDriversSummary = ({data, selectedImpactKey, onImpactSelect}) => {
    const theme = useTheme();
    const summary = data?.summary;

    if (!summary) {
        return (
            <Paper style={{...theme.palette.contentPanel, padding: 20, height: 400}}>
                <Typography variant="h6">Profit Drivers</Typography>
                <Typography variant="body2" color="textSecondary" style={{marginTop: 20}}>
                    No data available
                </Typography>
            </Paper>
        );
    }

    return (
        <Paper style={{...theme.palette.contentPanel, padding: 20}}>
            <Typography variant="h6" gutterBottom>Profit Drivers</Typography>
            <TableContainer>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Impact Category</TableCell>
                            <TableCell align="right">Impact</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {SUMMARY_ROWS.map((row) => {
                            const rowData = summary[row.key] || {impact: 0};
                            const impactColor = rowData.impact >= 0
                                ? theme.palette.indicator.green
                                : theme.palette.indicator.red;
                            const selectable = isRowSelectable(row);
                            const isSelected = selectedImpactKey === row.key;

                            return (
                                <TableRow
                                    key={row.key}
                                    hover={selectable}
                                    onClick={selectable ? () => onImpactSelect?.(row) : undefined}
                                    style={{
                                        fontWeight: row.isBold ? 'bold' : 'normal',
                                        borderTop: row.isBold ? '2px solid #323D72' : 'none',
                                        height: '42px',
                                        cursor: selectable ? 'pointer' : 'default',
                                        backgroundColor: isSelected ? 'rgba(50, 61, 114, 0.12)' : undefined
                                    }}
                                >
                                    <TableCell style={{fontWeight: row.isBold ? 'bold' : 'normal'}}>
                                        {row.label}
                                    </TableCell>
                                    <TableCell
                                        align="right"
                                        style={{
                                            color: impactColor,
                                            fontWeight: row.isBold ? 'bold' : 'normal'
                                        }}
                                    >
                                        {formatCurrency(rowData.impact, 0)}
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
};
